import { useId, useState } from 'react'

export function DirectoryBio({bio,name}:{bio:string;name:string}){
  const [expanded,setExpanded]=useState(false)
  const contentId=useId()
  const characters=Array.from(bio)
  const long=characters.length>300
  const text=long&&!expanded?characters.slice(0,300).join('').trimEnd()+'…':bio
  return <div className="directory-bio">
    <p id={contentId}>{text||'No bio added yet.'}</p>
    {long&&<button type="button" className="directory-bio-toggle" aria-expanded={expanded} aria-controls={contentId} aria-label={(expanded?'Show less':'Read more')+' about '+name} onClick={()=>setExpanded(value=>!value)}>{expanded?'Show less':'Read more'}</button>}
  </div>
}
